import PropTypes from 'prop-types';
import React from 'react';

import RunDocumentItem from './_run-document-item';

const RunDocuments = ({ documents, users }) => (
  documents.length ? documents.map(document => (
    <RunDocumentItem
      key={document.uri}
      document={document}
      userList={users}
    />
  )) : <p className="run-document-item__text m-0 text-center">You have no documents attached to this run.</p>
);

export default RunDocuments;

RunDocuments.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({})),
  users: PropTypes.shape({}),
}
